export const title = 'Mail Masivo';
export const searchClients = 'Buscar clientes según entradas';
export const listClients = 'Listado de clientes';
export const createMail = 'Creación del mail';
export const error = 'No se han encontrado usuarios con estos términos';
export const emailSent = 'Se ha enviado el email';
